import type { ComponentPropsWithoutRef } from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import styled, { css } from 'styled-components';

const ProductRatioContainer = styled.div<{ maxWidth?: string; ratioHeight: number; ratioWidth: number }>`
    position: relative;
    width: 100%;
    ${({ maxWidth }) =>
        maxWidth &&
        css`
            max-width: ${maxWidth};
        `}

    &::before {
        content: '';
        width: 1px;
        margin-left: -1px;
        float: left;
        height: 0;
        padding-top: ${({ ratioWidth, ratioHeight }) => `calc(${ratioWidth} / ${ratioHeight} * 100%)`};
    }

    &::after {
        content: '';
        display: table;
        clear: both;
    }
`;

const AbsoluteContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

interface AspectRatio {
    maxWidth?: string;
    ratioHeight?: number;
    ratioWidth?: number;
}

function AspectRatioContainer({
    children,
    maxWidth,
    ratioHeight = 1, // default ratio is 1:1, a perfect square
    ratioWidth = 1, // default ratio is 1:1, a perfect square
    ...restProps
}: AspectRatio & ComponentPropsWithoutRef<'div'>) {
    return (
        <ProductRatioContainer maxWidth={maxWidth} ratioHeight={ratioHeight} ratioWidth={ratioWidth} {...restProps}>
            <AbsoluteContainer>{children}</AbsoluteContainer>
        </ProductRatioContainer>
    );
}

/**
 * @deprecated if you need an aspect ratio container, style your element with aspect-ratio in css
 */
export default withErrorBoundary(AspectRatioContainer, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
